import { TimePicker } from "antd";
import { IObject } from "../App";
import { disabledHoursForDate, disabledMinutesForSelectedDateAndHour } from "../api/Worktime";
import { Dayjs } from "dayjs";

type Enumerate<N extends number, Acc extends number[] = []> = Acc['length'] extends N ? Acc[number] : Enumerate<N, [...Acc, Acc['length']]>;
type IntRange<F extends number, T extends number> = Exclude<Enumerate<T>, Enumerate<F>>;

type EndTimePickerProps = {
    object: IObject;

    format: string;
    selectedDate: Date | undefined;
    endTime: Dayjs | null;
    onChangeEndTime: (endTime: Dayjs | null) => void;
    disabled: boolean;
    offsetStart?: number;
    startTime: Dayjs | undefined;
};

export function EndTimePicker(props: EndTimePickerProps) {

    function getMinuteStep(interval: number): IntRange<1, 59>|undefined  { 
        if(interval < 0 || interval > 59) {
            return undefined;
        } else {
            return interval as IntRange<1, 59>;
        }        
    }

    return (
        <TimePicker 
            style={{width: '100%'}} 
            format={props.format} 
            minuteStep={getMinuteStep(props.object.interval)} 
            onChange={(value) => props.onChangeEndTime(value)} 
            onSelect={(value) => props.onChangeEndTime(value)}
            disabledHours={() => disabledHoursForDate(props.selectedDate, props.object, 0, props.offsetStart, 0, props.startTime)} 
            disabledMinutes={(hour) => disabledMinutesForSelectedDateAndHour(props.selectedDate, hour, props.object, 0, props.offsetStart, 0, props.startTime)}
            inputReadOnly={true} 
            hideDisabledOptions={true}
            value={props.endTime}
            showNow={false}
            disabled={props.disabled}
        /> 
    );
}